import React, { useEffect, useState } from "react";
import "./NewsSection.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

const NewsSection = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta"; // fallback to Tamil
  const [latestNews, setLatestNews] = useState([]);

useEffect(() => {
  axios
    .get("https://admin.cmpranesh-admk.com/api/getNews.php")
    .then(res => {
      const news = res.data.slice(0, 3);
      setLatestNews(news);
    })
    .catch(err => console.error("Error fetching news:", err));
}, []);


  // Helper function to format date
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString(
      lang === "ta" ? "ta-IN" : "en-US",
      { day: "2-digit", month: "short", year: "numeric" }
    );
  };

  return (
    <section className="newsSectionWrapper">
      <h2 className="newsSectionTitle">
        {lang === "ta" ? "சமீபத்திய செய்திகள் & புதுப்பிப்புகள்" : "Latest News & Updates"}
      </h2>

      <div className="newsCardContainer">
        {latestNews.map((item) => (
          <div key={item.id} className="newsCard">

            {/* IMAGE */}
            <Link to={`/news/${item.id}`}>
              <img
  src={`https://admin.cmpranesh-admk.com/${item.image}`}
  alt={lang === "ta" ? item.title_ta : item.title_en}
  className="newsCardImage"
/>
            </Link>

            {/* DATE */}
            <p className="newsCardDate">{formatDate(item.date)}</p>

            {/* TITLE */}
            <p className="newsCardTitle">{lang === "ta" ? item.title_ta : item.title_en}</p>

            {/* SHORT DESCRIPTION */}
            <p className="newsCardDesc">{lang === "ta" ? item.shortDesc_ta : item.shortDesc_en}</p>

            {/* READ MORE BUTTON */}
            <Link to={`/news/${item.id}`}>
              <button className="newsCardReadMore">
                {lang === "ta" ? "மேலும் படிக்க.." : "Read More.."}
              </button>
            </Link>

          </div>
        ))}
      </div>

      <div className="newsExploreContainer">
        <Link to="/news" className="newsExploreBtn">
          {lang === "ta" ? "மேலும் செய்திகள் படிக்க →" : "Explore More News →"}
        </Link>
      </div>
    </section>
  );
};

export default NewsSection;
